// src/app/services/posthog.service.ts
import { Injectable, NgZone } from "@angular/core";
import posthog from "posthog-js";
import { environment } from "environments/environment";

@Injectable({ providedIn: "root" })
export class PosthogService {
  private initialized = false;

  constructor(private ngZone: NgZone) { }

  init() {
    if (environment.production) {
      if (this.initialized) return;

      this.ngZone.runOutsideAngular(() => {
        posthog.init(environment.posthogKey, {
          api_host: environment.posthogHost,
          autocapture: false,
          capture_pageview: false,
          capture_pageleave: false,
          disable_session_recording: true
        });
      });

      this.initialized = true;
    }
  }

  identify(user: any) {
    if (environment.production) {
      this.ngZone.runOutsideAngular(() => {
        posthog.identify(user.userName, {
          email: user.emailAddress,
          name: user.fullName,
        });
      });
    }
  }
}